module.exports = __webpack_public_path__ + "img/cement-batcher.c917d319.png";